import React from "react";
import OpenEventsDashboard from "./OpenEventsDashboard";
import { ViewEventTypeProvider } from "../../providers/ViewEventTypeProvider";
import { useAuthorization } from "meportal/AuthorizationProvider";

import { ViewLiveEventType } from "../../constants/PermissionSet";

function AuthorizedDashboard() {
    const {eventPermissions, userClaims} = useAuthorization();


return (
    <ViewEventTypeProvider permission={ViewLiveEventType}>
        <OpenEventsDashboard />
    </ViewEventTypeProvider>
);

}
export default AuthorizedDashboard;